// Quantity Selector

document.querySelector('.plus-input').addEventListener('click', () => {
  let currentValue = Number(document.querySelector('#qty').value);
  document.querySelector('#qty').value = currentValue + 1;
});

document.querySelector('.minus-input').addEventListener('click', () => {
  let currentValue = Number(document.querySelector('#qty').value);

  if (currentValue > 1) {
    document.querySelector('#qty').value = currentValue - 1;
  }
});

// Accordion

var acc = document.querySelectorAll(".accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    var isActive = this.classList.contains("active");
    if (isActive) {
      var panel = this.nextElementSibling;
      panel.style.maxHeight =  "0px";
      this.classList.remove("active");
    } else {
      // Loop over all the panels an close each one
      document.querySelectorAll(".panel").forEach(function (panel) {
        panel.style.maxHeight = "0";
        panel.previousElementSibling.classList.remove("active");
      });

      // Then show the clicked panel
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      panel.style.maxHeight = "100%";
    }
  });
}
